'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageStyle = {
  float: 'left',
  marginRight: 10
};

var linkStyle = {
  fontSize: 18,
  fontWeight: 'bold',
  color: '#20c49e'
};

var authorStyle = {
  fontSize: 14,
  fontWeight: 'bold',
  textAlign: 'right',
  display: 'block'
};

var viewPostStyle = {
  height: 40
};

var Comment = function Comment(_ref) {
  var id = _ref.id,
      handle = _ref.handle,
      text = _ref.text,
      author = _ref.author,
      username = _ref.username,
      profilePic = _ref.profilePic,
      followersCount = _ref.totals.followersCount,
      assetURL = _ref.asset.trackedAsset.assetURL;
  return _react2.default.createElement(
    _semanticUiReact.Card,
    null,
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(_semanticUiReact.Image, { style: imageStyle, src: profilePic, size: 'mini', circular: true }),
      _react2.default.createElement(
        'b',
        null,
        handle
      ),
      _react2.default.createElement('br', null),
      (0, _formatting.commaFormatted)(followersCount),
      ' followers'
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      text,
      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitter: true }),
      _react2.default.createElement(
        'span',
        { style: authorStyle },
        '@',
        username
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { textAlign: 'center', style: viewPostStyle },
      _react2.default.createElement(
        'a',
        { target: '_blank', style: linkStyle, rel: 'noopener noreferrer', href: assetURL + '/c/' + id },
        'view post'
      )
    )
  );
};

Comment.propTypes = {
  text: _propTypes2.default.string.isRequired
};

exports.default = Comment;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/tiktok-report/comment.js
// module id = 2203
// module chunks = 1